<template>
  <div v-if="visible">
    <div :style="{margin: '0px 30px 15px', paddingTop: '20px',fontSize: '15px'}">
      <p :style="{color: 'white'}">
        <a-icon
          type="bulb"
          :style="{fontSize: '20px'}"
        /> 共分为 {{ dataForm.length }} 个部分，{{ totalScore }}.0 分</p>
    </div>
    <div
      class="innerbox"
      :style="{borderRadius: '5px',height:'530px',margin: '0px 30px',backgroundColor: 'white',overflow:'auto'}"
    >
      <div
        v-for="(item,index) in dataForm"
        :key="index"
        :style="{paddingTop: '15px', paddingLeft: '30px',paddingRight:'30px'}"
      >
        <div
          v-if="index % 2 == 0"
          :style="{backgroundColor: '#cfe7e7',height:'50px',lineHeight:'50px',borderRadius: '5px'}"
        >
          <b :style="{margin: '20px'}">{{ item .title }}</b>
          <span><b :style="{float: 'right',marginRight:'30px'}">{{ item.totalScore }}.0 分</b></span>
        </div>
        <div
          v-else
          :style="{backgroundColor: '#f2f2f2',height:'50px',lineHeight:'50px',borderRadius: '5px'}"
        >
          <b :style="{margin: '20px'}">{{ item .title }}</b>
          <span><b :style="{float: 'right',marginRight:'30px'}">{{ item.totalScore }}.0 分</b></span>
        </div>
      </div>
      <a-divider />
    </div>
    <div
      :style="{textAlign:'center',marginTop:'25px'}"
      v-if="typeof (examForm.scoreId) !== 'undefined'"
    >
      <p
        :style="{cursor:'pointer'}"
        @click="handelLastScore"
      >查看成绩：
        {{ examForm.score }}.0 分
        <a-rate
          v-model="examForm.starNum"
          allowHalf
          disabled
          :style="{fontSize:'10px'}"
        />
      </p>
    </div>
    <div
      :style="{textAlign:'center',marginTop:'50px'}"
      v-else
    >
      <a-button
        type="primary"
        :style="{width: '20%'}"
        @click="onStart"
      >开始作业</a-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FirstForm',
  data () {
    return {
      visible: false,
      dataForm: {},
      examForm: {},
      totalScore: 0
    }
  },
  created () {
    // this.dataForm = this.value
  },
  methods: {
    handleOpen (examForm, value) {
      this.visible = true
      this.dataForm = value
      this.examForm = examForm
      // console.log('value:' + JSON.stringify(value))
      this.handleTotalScore()
    },
    // 开始练习
    onStart () {
      this.visible = false
      this.$emit('changeFirst')
    },
    // 重新练习
    onAgainStart () {
      this.visible = false
      this.$emit('onAgainStart')
    },
    // 计算总分
    handleTotalScore () {
      this.dataForm.forEach((item, i) => {
        this.totalScore += item.totalScore
      })
    },
    // 查看上次成绩
    handelLastScore () {
      this.visible = false
      this.$emit('handelLastScore')
    }
  }
}
</script>
<style>
.innerbox::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.innerbox::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px #f5f5f5;
  background: rgba(0, 0, 0, 0.2);
}
.innerbox::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
